import React from 'react'

export function Tickets() {
    return (
        <div className="tickets_container"></div>
    )
}